import jwt_decode from "jwt-decode";
import { initialStateAuth, setCredentials } from "../store/feautures/AuthSlice";
import { Dispatch } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

/**
 * Decodifica un accessToken JWT, aggiorna lo store con le credenziali utente
 * e mostra un toast di successo personalizzabile.
 */
export const decodeJwtAndSetCredentials = (
  dispatch: Dispatch,
  onSuccess: () => void, // callback es. navigate
  tokens: { accessToken: string; refreshToken?: string },
  successMessage?: string, // nuovo parametro per il toast
  showError?: (msg: string) => void,
) => {
  try {
    const decoded: any = jwt_decode(tokens.accessToken);
    const name = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"];
    const lastname = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname"];
    const role = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
    const id = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];
    const regioniPertinenzaRaw = decoded["regioni_pertinenza"];

    // Aggiorna lo store
    dispatch(
      setCredentials({
        token: tokens.accessToken,
        refreshToken: tokens.refreshToken,
        name,
        lastname,
        role,
        id,
        regioniPertinenza: regioniPertinenzaRaw,
      })
    );

    // Mostra toast di successo personalizzato
    if (successMessage) {
      toast.success(successMessage);
    }

    // Callback es. navigate
    onSuccess();
  } catch (error) {
    dispatch(setCredentials(initialStateAuth));
    showError && showError("Ops: controlla le tue credenziali");
  }
};